import React from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import CountStatusBarComponent from "../Board/CountStatusBarComponent";

class AgGridComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
           statusBar: {
        statusPanels: [
          {
            statusPanel: CountStatusBarComponent,
          },
        ],
      },
    };
  }
 

  render() {

    const onSelectionChanged = (event) => {
      console.log("countrow", event.api.getSelectedRows())
    }
    const isRowSelectable = (node) => {
      console.log("countrow", node)

    }
    return (
      <div
        className="ag-theme-material"
        style={{ height: "100%", width: "100%" }}
      >
        <AgGridReact
          style={{ height: "100%", width: "100%" }}
          rowData={this.props.data}
          frameworkComponents={this.props.frameworkComponents}
          defaultColDef={{ flex: 1, minWidth: 180 }}
          columnDefs={this.props.columns}
          reactUi="true"
          // rowSelection="multiple"
          onSelectionChanged={this.props.onSelectionChanged}
          rowMultiSelectWithClick={true}
          RowSelectable={this.props.isRowSelectable}
          animateRows={true}
          onGridReady={this.props.onGridReady}
          pagination={true}
          cacheQuickFilter={true}
          paginationPageSize={this.props.paginationPageSize}
          statusBar={this.state.statusBar}
          suppressPaginationPanel={true}
          paginationPageSize={this.props.paginationPageSize}
          paginationNumberFormatter={this.props.paginationNumberFormatter}
          onFirstDataRendered={this.props.onFirstDataRendered}
          onCellValueChanged={this.props.onCellValueChanged}
          clearSelectedRows={this.props.toggledClearRows}
        ></AgGridReact>
        <div style={{ height: 20 }}></div>

      </div>
    );
  }
}

export default AgGridComponent;
